import { Button, Dialog, Drawer } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Image from 'next/image';
import { FC } from 'react';
import { IConfirmModalTms } from '../../../interfaces/components/modal.interface';

const ConfirmModal: FC<IConfirmModalTms> = ({
  color = 'primary',
  title,
  description,
  cancelContent = 'Hủy',
  confirmContent = 'Đồng ý',
  open,
  onClose,
  cancelCallback,
  confirmCallback,
  fullWidth = false,
  maxWidth = 'sm',
}) => {
  const handleConfirm = () => {
    confirmCallback();
    onClose();
  };
  const matches = useMediaQuery('(min-width:768px)');

  const colorConfirmBtnMapping = {
    primary:
      '!bg-primary_lighter hover:!bg-primary_lighter !border !border-solid !border-primary_lighter',
    secondary: '!bg-error hover:!bg-error !border !border-solid !border-error',
    success:
      '!bg-success_main hover:!bg-success_main !border !border-solid !border-success_main',
  };

  return matches ? (
    <Dialog
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      onClose={onClose}
      open={open}
      className="z-[1000000]"
    >
      <div className="flex flex-col gap-y-4 p-4">
        <h1 className="text-xl font-semibold">{title}</h1>
        <div>{description}</div>
        <div className="flex w-full items-center justify-end gap-x-2">
          <Button
            style={{ textTransform: 'none' }}
            className="!border !border-solid !border-gray-300 !bg-white !text-slate_gray hover:!bg-white"
            onClick={cancelCallback}
          >
            {cancelContent}
          </Button>{' '}
          <Button
            style={{ textTransform: 'none' }}
            className={`!text-white ${colorConfirmBtnMapping[color]}`}
            onClick={handleConfirm}
          >
            {confirmContent}
          </Button>
        </div>
      </div>
    </Dialog>
  ) : (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        square: false,
        style: {
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
          borderBottomLeftRadius: '0px',
          borderBottomRightRadius: '0px',
        },
      }}
    >
      <div className="flex items-center justify-between p-3 px-5 pb-2 text-xl font-bold">
        {title}
        <div className="cursor-pointer" onClick={cancelCallback}>
          <Image src="/icons/x.svg" width={10} height={10} alt="close" />
        </div>
      </div>
      <div className="flex h-full flex-col justify-between px-5 pb-10 pt-2">
        <p>{description}</p>
        <div className="flex w-full flex-col  gap-y-3 pt-16">
          <Button
            style={{ textTransform: 'none' }}
            className={`!text-white ${colorConfirmBtnMapping[color]}`}
            onClick={handleConfirm}
          >
            {confirmContent}
          </Button>
          <Button
            style={{ textTransform: 'none' }}
            className="!border-2 !border-solid !border-gray-300 !bg-white !text-black hover:!bg-white"
            onClick={cancelCallback}
          >
            {cancelContent}
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export const ConfirmModalVerse2: FC<IConfirmModalTms> = ({
  color = 'primary',
  title,
  description,
  cancelContent = 'Hủy',
  confirmContent = 'Đồng ý',
  open,
  onClose,
  cancelCallback,
  confirmCallback,
  fullWidth = false,
  maxWidth = 'sm',
  buttonFloatRight = false,
}) => {
  const handleConfirm = () => {
    confirmCallback();
    onClose();
  };
  return (
    <Dialog
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      onClose={onClose}
      open={open}
    >
      <div className="flex flex-col gap-y-4 p-4">
        <h1 className="text-xl font-bold">{title}</h1>
        <div>{description}</div>
        <div
          className={`flex w-full ${
            buttonFloatRight ? 'justify-end' : 'justify-center'
          } items-center gap-x-2`}
        >
          <Button
            style={{ textTransform: 'none' }}
            className={`!bg-white !text-Primary/Main hover:!bg-white ${
              buttonFloatRight || '!flex-1'
            }`}
            onClick={cancelCallback}
          >
            {cancelContent}
          </Button>{' '}
          <Button
            style={{ textTransform: 'none' }}
            className={`!text-white ${buttonFloatRight || '!flex-1'} ${
              color === 'primary'
                ? '!border !border-solid !border-primary_lighter !bg-primary_lighter hover:!bg-primary_lighter'
                : '!border !border-solid !border-error !bg-error hover:!bg-error'
            }`}
            onClick={handleConfirm}
          >
            {confirmContent}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmModal;
